module.exports = {"qwilink":{"is":true},"authConnection":{"attemptedConnection":false,"onboardingShop":false,"destination":null},"translations":{},"apiRequests":{"failed":null,"all":null},"impersonation":{"impersonating":false},"altUser":{},"user":{"id":null,"email":null,"token":null,"name":null,"roles":[],"new":false,"tourShown":false,"permissions":{},"settings":{},"contact":{"companyName":null,"vatId":null,"contactPerson":null,"phone":null,"email":null,"address":null,"postalCode":null,"city":null,"country":null}},"interface":{"language":null},"campaignCreatorState":{}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurations/localStorageStructure.json
// module id = vt38
// module chunks = 53